module.exports = __webpack_public_path__ + "img/sending.71349bc6.gif";